module.exports = __webpack_public_path__ + "static/media/Roboto-Italic.de74c609.ttf";